export const baseSelector = (state) => state.dff.baseUrl;
